import { Pipe, PipeTransform } from "@angular/core";
import { ICDay } from "../models/entities/icday";

@Pipe({ name: "orderByDay" })
export class OrderByDayPipe implements PipeTransform {
  transform(value: { Day: ICDay }[]): any[] {
    if (value == null || value.length == 0) {
      return [];
    }
    return value.sort((a, b) => a.Day.DayCode - b.Day.DayCode);
  }
}
